import { render, staticRenderFns } from "./trainingModulePageNew3.vue?vue&type=template&id=2c9e4f6b&scoped=true&"
import script from "./trainingModulePageNew3.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew3.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew3.vue?vue&type=style&index=0&id=2c9e4f6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e4f6b",
  null
  
)

export default component.exports